import { render, staticRenderFns } from "./block-clock.vue?vue&type=template&id=6532f0fe&scoped=true"
import script from "./block-clock.vue?vue&type=script&lang=js"
export * from "./block-clock.vue?vue&type=script&lang=js"
import style0 from "./block-clock.vue?vue&type=style&index=0&id=6532f0fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6532f0fe",
  null
  
)

export default component.exports